import { Link, useNavigate } from 'react-router-dom'
import { useCart } from '../contexts/CartContext'
import { useAuth } from '../contexts/AuthContext'
import { formatCurrency } from '../lib/db'
import './Cart.css'

export default function Cart() {
    const { items, updateQuantity, removeItem, getSubtotal, getItemCount } = useCart()
    const { user, signIn } = useAuth()
    const navigate = useNavigate()

    const handleCheckout = () => {
        if (!user) {
            signIn()
            return
        }
        navigate('/checkout')
    }

    if (items.length === 0) {
        return (
            <div className="container">
                <div className="empty-cart">
                    <span className="empty-cart-icon">🛒</span>
                    <h2>Your cart is empty</h2>
                    <p>Looks like you haven't added any items yet</p>
                    <Link to="/" className="btn btn-primary btn-lg">
                        Start Shopping
                    </Link>
                </div>
            </div>
        )
    }

    return (
        <div className="container">
            <div className="cart-page">
                <div className="cart-header">
                    <h1>Shopping Cart</h1>
                    <span className="cart-count">{getItemCount()} items</span>
                </div>

                <div className="cart-content">
                    {/* Cart Items */}
                    <div className="cart-items">
                        {items.map(({ product, quantity }) => (
                            <div key={product.id} className="cart-item">
                                <div className="cart-item-image">
                                    {product.image_url ? (
                                        <img src={product.image_url} alt={product.name} />
                                    ) : (
                                        <div className="item-placeholder">👗</div>
                                    )}
                                </div>

                                <div className="cart-item-details">
                                    <Link to={`/product/${product.id}`} className="cart-item-name">
                                        {product.name}
                                    </Link>
                                    <span className="cart-item-category">{product.category}</span>

                                    <div className="cart-item-prices">
                                        <span className="cart-item-sm-price">{formatCurrency(product.sm_price)}</span>
                                        {product.mrp > product.sm_price && (
                                            <span className="cart-item-mrp">{formatCurrency(product.mrp)}</span>
                                        )}
                                    </div>
                                </div>

                                <div className="cart-item-actions">
                                    <div className="quantity-controls-small">
                                        <button
                                            onClick={() => updateQuantity(product.id, quantity - 1)}
                                            disabled={quantity <= 1}
                                        >
                                            −
                                        </button>
                                        <span>{quantity}</span>
                                        <button
                                            onClick={() => updateQuantity(product.id, quantity + 1)}
                                            disabled={quantity >= product.stock}
                                        >
                                            +
                                        </button>
                                    </div>

                                    <div className="cart-item-total">
                                        {formatCurrency(product.sm_price * quantity)}
                                    </div>

                                    <button
                                        className="remove-btn"
                                        onClick={() => removeItem(product.id)}
                                        title="Remove item"
                                    >
                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                            <path d="M3 6h18M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
                                        </svg>
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* Cart Summary */}
                    <div className="cart-summary">
                        <div className="summary-card">
                            <h3>Order Summary</h3>

                            <div className="summary-row">
                                <span>Subtotal ({getItemCount()} items)</span>
                                <span>{formatCurrency(getSubtotal())}</span>
                            </div>

                            <div className="summary-row">
                                <span>Savings</span>
                                <span className="text-success">
                                    -{formatCurrency(items.reduce((sum, { product, quantity }) =>
                                        sum + (product.mrp - product.sm_price) * quantity, 0
                                    ))}
                                </span>
                            </div>

                            <hr />

                            <div className="summary-row total">
                                <span>Total</span>
                                <span>{formatCurrency(getSubtotal())}</span>
                            </div>

                            <div className="scoins-earn-info">
                                <span className="scoins-icon">🪙</span>
                                <span>You'll earn <strong>{Math.floor(getSubtotal() / 100) * 10} S-Coins</strong></span>
                            </div>

                            <button
                                className="btn btn-primary btn-lg checkout-btn"
                                onClick={handleCheckout}
                            >
                                {user ? 'Proceed to Checkout' : 'Sign in to Checkout'}
                            </button>

                            <Link to="/" className="continue-shopping">
                                ← Continue Shopping
                            </Link>
                        </div>

                        {/* Pickup Info */}
                        <div className="pickup-info-card">
                            <div className="pickup-icon">🏪</div>
                            <h4>Pay Now & Pickup at Store</h4>
                            <p>Pay via UPI and collect your order at our Nalgonda store. Show your pickup code to receive your items.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
